import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'expandAka',
	pure: true,
})
export class ExpandAkaPipe implements PipeTransform {
	transform(value: string): string {
		return value.replace('AKA', 'also known as');
	}
}
